import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styled from 'styled-components';
import { Container } from 'semantic-ui-react';
import Svg from 'react-inlinesvg';
import { logoShape } from '../images';

const StyledLoader = styled(Container)`
  @keyframes slideUpIn {
    0% {
      transform: translateY(10px);
      opacity: 0;
    }
    10% {
      transform: translateY(0);
      opacity: 0.5;
    }
    75% {
      opacity: 1;
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }

  position: relative;
  height: 100vh;
  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 144px;
    height: auto;
    overflow: visible;
    path {
      opacity: 0;
    }

    path:nth-child(1) {
      animation: slideUpIn 3s cubic-bezier(0.2, 0.8, 0.2, 1) 0.25s infinite;
    }
    path:nth-child(2) {
      animation: slideUpIn 3s cubic-bezier(0.2, 0.8, 0.2, 1) 0.2s infinite;
    }
    path:nth-child(3) {
      animation: slideUpIn 3s cubic-bezier(0.2, 0.8, 0.2, 1) 0.15s infinite;
    }
    path:nth-child(4) {
      animation: slideUpIn 3s cubic-bezier(0.2, 0.8, 0.2, 1) 0.1s infinite;
    }
    path:nth-child(5) {
      animation: slideUpIn 3s cubic-bezier(0.2, 0.8, 0.2, 1) 0.05s infinite;
    }
    path:nth-child(6) {
      animation: slideUpIn 3s cubic-bezier(0.2, 0.8, 0.2, 1) infinite;
    }
  }

  /* namespace'd */
  &.pageloader {
    &--fixed {
      position: fixed;
      top: 0;
      left: 0;
      background: #fff;
      z-index: 999;
      margin: 0 !important;
      width: 100vw !important;
    }
  }
`;

const PageLoader = ({ fixed = false }) => (
  <StyledLoader textAlign="center" className={cn(fixed && 'pageloader--fixed')}>
    <Svg src={logoShape} />
  </StyledLoader>
);

PageLoader.propTypes = {
  fixed: PropTypes.bool
};
export default PageLoader;



// WEBPACK FOOTER //
// ./src/components/PageLoader.js